import { render, staticRenderFns } from "./FreeTextSubOrder.vue?vue&type=template&id=04dad1b4&scoped=true&"
import script from "./FreeTextSubOrder.vue?vue&type=script&lang=js&"
export * from "./FreeTextSubOrder.vue?vue&type=script&lang=js&"
import style0 from "./FreeTextSubOrder.vue?vue&type=style&index=0&id=04dad1b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04dad1b4",
  null
  
)

/* custom blocks */
import block0 from "./FreeTextSubOrder.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports